import { Label } from '@upme/ui/components/label';
import type { ReactNode } from 'react';

interface WordListFieldProps {
  id: string;
  label: ReactNode;
  value: string;
  onChange: (value: string) => void;
  /** Доптекст под полем (предупреждение для неизвестных категорий). */
  note?: string;
}

const countWords = (v: string) =>
  v
    .split(',')
    .map((s) => s.trim())
    .filter(Boolean).length;

/** Список слов «через запятую»: label + растущая textarea + счётчик. */
export function WordListField({ id, label, value, onChange, note }: WordListFieldProps) {
  return (
    <div className="space-y-1.5">
      <Label htmlFor={id}>{label}</Label>
      <textarea
        id={id}
        rows={Math.max(2, Math.ceil(value.length / 70))}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        className="flex w-full rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2"
      />
      <p className="text-xs text-muted-foreground">
        слов: {countWords(value)}
        {note ? ` · ${note}` : ''}
      </p>
    </div>
  );
}
